import { gql } from '@apollo/client';

export interface DocumentPresignedUrlResult {
  supplierDocsPresignedURL: {
    url: string;
  };
}

export const DOCUMENT_PRESIGNED_URL = gql`
  query($key: String!) {
    supplierDocsPresignedURL(key: $key) {
      url
    }
  }
`;
